import React, { useContext } from 'react';
import { Button } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import BillingContext from '@totem/components/ticketing/billing/billingContext';
import BillinDialog from '@totem/components/ticketing/billing/billingDialog';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNull } from '@totem/utilities/common';

const ButtonCreateBilling = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { selectedUnbilled, action, onAction } = useContext(BillingContext);

  return (
    <>
      {permissions.billingAdministratorIBOrg.hasPermissions(userProfile) && (
        <IBTooltip content={permissions.billingAdministratorIBOrg.tooltip}>
          <Button
            type="primary"
            onClick={() => onAction('create-billing', '')}
            disabled={
              isNull(selectedUnbilled) ||
              selectedUnbilled.length === 0 ||
              action === 'create-billing'
            }
          >
            Create Billing
          </Button>
        </IBTooltip>
      )}

      {action === 'create-billing' && <BillinDialog />}
    </>
  );
};

export default ButtonCreateBilling;
